<template>
    <datepicker :open-date="openDate" :placeholder="placeholder ? placeholder : ''"
        :format="format ? format : 'DD/MM/YYYY'" :monday-first="true" :full-month-name="true"
        wrapper-class="currency-datepicker__wrapper mb-3" :class="{ input_red_shadow: hasError }"
        input-class="currency-datepicker__input" calendar-class="currency-datepicker__element bottom-100"
        v-model="localDate" :disabled="disabled" :highlighted="localDate ? {} : highlightedConfig"
        :disabled-dates="disabledDates" />
</template>

<script>
import Datepicker from '@/components/DatepickerCustom/src/components/Datepicker';

export default {
    name: "CustomDatepicker",
    components: { Datepicker },
    props: {
        date: {
            required: true,
        },
        disableDate: {
            type: Boolean,
            default: false,
        },
        placeholder: {},
        format: {},
        hasError: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        birthdate: {
            type: Boolean,
            default: false,
        }
    },
    watch: {
        localDate() {
            this.$emit('update:date', this.localDate);
        },
        date() {
            this.localDate = this.date;
        }
    },
    data() {
        return {
            localDate: this.birthdate && !this.date
                ? null
                : this.date,

            openDate: this.birthdate
                ? new Date(
                    new Date().setFullYear(
                        new Date().getFullYear() - 18
                    )
                )
                : new Date(),

            highlightedConfig: this.birthdate
                ? {
                    dates: [
                        new Date(
                            new Date().setFullYear(
                                new Date().getFullYear() - 18
                            )
                        )
                    ],
                }
                : {
                    dates: [new Date()],
                },


            disabledDates: this.birthdate
                ? {
                    from: new Date(
                        new Date().getFullYear() - 18,
                        new Date().getMonth(),
                        new Date().getDate() + 1
                    )
                }
                : this.disableDate
                    ? {
                        to: new Date(
                            new Date().getFullYear(),
                            new Date().getMonth(),
                            new Date().getDate()
                        )
                    }
                    : {},

        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/CustomInputs/CustomDatepicker.vue